module.exports = __webpack_public_path__ + "static/media/tcr-logo-light-2.5f51e507.png";